module.exports = {
	"imgNavPic": require("@/assets/data/img/about_article/about_menu_title.png"),
	"aNavMenu": {
		"/about": {
			"name": "公司简介",
			"imgHead":require("@/assets/data/img/about_article/公司简介.png"),
			"content": [{
					"name": "公司介绍",
					"text": [
						"厦门酷联客电子科技有限公司（简称“酷联客”）创立于2014年1月，坐落于厦门市湖里区园山南路806号，是一家物联网（IOT）开放式接入服务云平台的公司，面向产业提供联网服务，并以此为核心展开一系列增值服务运营。",
						"酷联客硬件产品方面有物联网链接器、物联网嵌入式模块等。公司拥有强大的嵌入式软硬件研发团队, 手机程序开发以及服务器程序开发团队, 可为客户提供 OEM 和 ODM 服务。我们能提供从嵌入式硬件、嵌入式软件、上位机软件; 并提供私有云服务器, APP 开发等全方位的与联网控制相关的产品和服务，同时还提供私有云、互联网+、物联网联动、方便、易用、节能、可靠、高效的解决方案。",
					]
				},
				{
					"name": "酷联客事迹",
					"text": [
						"☆   <b>2014年</b>",
						"1月，公司成立，专注智能家居领域；",
						"5月，开发智能家居全套硬件及软件，以平台化方案开发进行；",
						"☆   <b>2015年</b>",
						"1月，酷联客转型为物联网公司，物联网接入平台上线运营；",
						"10月，中国互联网协会会员单位；",
						"☆   <b>2016年</b>",
						"1月，酷联客构建的物联网链接服务完善；",
						"6月，荣获“物联中国”年度盛典“白鹭奖”最具投资价值物联网项目“百佳项目”；",
						"7月，Qiot物联网控制软件开发项目启动；",
						"10月，Qiot正式公测；",
						"10月，爱提醒物联网科技（漳州）有限公司成立；"
					]
				},
				{
					"name": "团队",
					"text": [
						"<b>软硬件全栈工程师</b>：拥有20年以上开发管理经验，熟悉软硬件通讯开发流程，熟悉项目管理，完成多套软硬件系统，主要负责公司内部网络系统和应用系统的开发。",
						"<b>运营总监</b>：拥有12年IT&物联网行业经验，特别在运营服务领域有独到见解。对于云计算行业、智能家居以及海量用户的运营服务有着丰富的经验。",
						"<b>IOT核心工程师</b>：拥有10年以上开发管理经验,熟悉软硬件通讯开发流程及项目管理，完成多套软硬件系统；2003-2009年曾就职于夏新股份有限公司，负责公司内部网络系统和应用系统的开发。",
						"<b>Android工程师</b>：拥有6年IT&物联网行业的研发管理经验，2011年6月毕业于华侨大学信号与信息处理专业硕士；2011年8月-2013年8月在南京诚迈股份有限公司，主要负责Android手机端研发底层ROM并带领团队做第三方APP；2013年8月-2014年8月就职于厦门立林软件有限公司，主要负责带团队研究立林智能家居的研发。",
						"<b>iOS工程师</b>：拥有8年工作经验，曾在北京汽车之家担任项目经理，厦门网龙网络科技有限公司担任项目经理。",
						"<b>前端工程师</b>：拥有5年Web开发经验，擅长HTML、CSS、Web后端开发，独立完成10个项目。",
						"<b>设计师</b>：拥有6年大公司平面广告设计经验，擅长UI设计，平面广告设计，美工设计。完成30余个项目UI的完整设计。",
					]
				},
			]
		},
		"/about/2": {
			"name": "联系我们",
			"imgHead":require("@/assets/data/img/about_article/联系我们.png"),
			"content": [{
					"name": "厦门",
					"text": [
						"厦门酷联客电子科技有限公司",
						"电话：0592-8222272",
						"地址：厦门市湖里区园山南路806号联发电子广场B座804室",
						"邮编：361006"
					]
				},
				{
					"name": "漳州",
					"text": [
						"福建爱提醒物联网科技有限公司",
						"电话：0596-2096918",
						"手机：王总 13306069090",
						"地址：福建省漳州高新区九湖镇众创园2栋4层",
						"邮编：363000"
					]
				}
			]
		},
		"/about/3": {
			"name": "新闻动态",
			"child": {
				"/about/3_1": {
					"name": "最新动态",
					"icon": "iconfont icon-zuixindongtai",
					"imgHead":require("@/assets/data/img/about_article/新闻动态-最新动态.png"),
					"content": [{
							"name": "近日动态",
							"text": [
								"暂无消息"
							]
						}
					]
				},
				"/about/3_2": {
					"name": "产品更新",
					"icon": "iconfont icon-chanpingengxin",
					"imgHead":require("@/assets/data/img/about_article/新闻动态-产品更新.png"),
					"content": [{
						"name": "产品更新",
						"text": [
							"暂无消息"
						]
					}]
				}
			}
		},
		"/about/4": {
			"name": "加入我们",
			"child": {
				"/about/4_1": {
					"name": "社会招聘",
					"icon": "iconfont icon-shehuizhaopin",
					"imgHead":require("@/assets/data/img/about_article/加入我们-社会招聘.png"),
					"content": [{
						"name": "社会招聘",
						"text": [
							"暂无消息"
						]
					}]
				},
				"/about/4_2": {
					"name": "校园招聘",
					"icon": "iconfont icon-xiaoyuanzhaopin",
					"imgHead":require("@/assets/data/img/about_article/加入我们-校园招聘.png"),
					"content": [{
						"name": "校园招聘",
						"text": [
							"暂无消息"
						]
					}]
				}
			}
		},
		"/about/5": {
			"name": "物联网初创企业成长计划",
			"imgHead":require("@/assets/data/img/about_article/初创企业成长计划.png"),
			"content": [{
				"name": "产品智能化流程",
				"text": [
					require("@/assets/data/img/about_article/初创企业成长计划_详情/产品智能化流程_详情_01.png"),
					require("@/assets/data/img/about_article/初创企业成长计划_详情/产品智能化流程_详情_02.png"),
					require("@/assets/data/img/about_article/初创企业成长计划_详情/产品智能化流程_详情_03.png")
				]
			},{
				"name": "玩转产品智能化发展进阶攻略",
				"text": [
					require("@/assets/data/img/about_article/初创企业成长计划_详情/玩转产品智能化发展进阶攻略_详情_01.png"),
					require("@/assets/data/img/about_article/初创企业成长计划_详情/玩转产品智能化发展进阶攻略_详情_02.png"),
					require("@/assets/data/img/about_article/初创企业成长计划_详情/玩转产品智能化发展进阶攻略_详情_03.png"),
					require("@/assets/data/img/about_article/初创企业成长计划_详情/玩转产品智能化发展进阶攻略_详情_04.png"),
					require("@/assets/data/img/about_article/初创企业成长计划_详情/玩转产品智能化发展进阶攻略_详情_05.png")
				]
			}]
		}
	}
}


// WEBPACK FOOTER //
// ./src/assets/data/about-article.js